// extracted by mini-css-extract-plugin
export var buttonIcon = "security-section-module--buttonIcon--036b2";
export var legalsForm = "security-section-module--legalsForm--0d062";
export var section = "security-section-module--section--8ee92";
export var title = "security-section-module--title--a3d33";